import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { TemplatePage } from '~/features/report-templates/template-page';

/** One saved template (step 8.3 of docs/plans/report-templates.md). */
function TemplateRoute(): ReactElement {
  const { recordId, templateId } = Route.useParams();
  return <TemplatePage key={templateId} recordId={recordId} templateId={templateId} />;
}

export const Route = createFileRoute('/_app/records/$recordId/report-templates/$templateId/')({ component: TemplateRoute });
